<article class="ts-page">
  <header class="ts-page__head">
    <app-spot kind="stitch" class="ts-page__spot"></app-spot>
    <p class="t-meta ts-page__eyebrow">Features</p>
    <h1 class="ts-page__title">Everything a long story <em>needs</em></h1>
    <p class="ts-page__lede">
      Talespinner follows a book from the first idea to the last page. Here is what it can do at each stage,
      in the order you'll probably meet it.
    </p>
  </header>

  <nav class="ts-stages-nav" aria-label="Stages">
    @for (stage of stages; track stage.id) {
      <a class="ts-stages-nav__link" [routerLink]="[]" [fragment]="stage.id">
        <span class="ts-stages-nav__number">{{ stage.number }}</span>
        {{ stage.title }}
      </a>
    }
  </nav>

  @for (stage of stages; track stage.id) {
    <section class="ts-stage" [id]="stage.id" [attr.aria-labelledby]="'ts-stage-' + stage.id" tsReveal>
      <div class="ts-stage__lead">
        <div class="ts-stage__mark">
          <p class="ts-stage__number" aria-hidden="true">{{ stage.number }}</p>
          <app-doodle [kind]="stage.doodle" class="ts-stage__doodle"></app-doodle>
        </div>
        <h2 class="ts-stage__title" [id]="'ts-stage-' + stage.id">{{ stage.title }}</h2>
        <p class="ts-stage__intro">{{ stage.intro }}</p>
        <aside class="ts-spark">
          <p class="t-meta ts-spark__label">Try this</p>
          <p class="ts-spark__text">{{ stage.spark }}</p>
        </aside>
      </div>

      <ul class="ts-stage__features">
        @for (feature of stage.features; track feature.title) {
          <li class="ts-stage__feature">
            <h3>{{ feature.title }}</h3>
            <p>{{ feature.body }}</p>
          </li>
        }
      </ul>
    </section>
  }

  <section class="ts-cta" aria-labelledby="ts-features-cta" tsReveal>
    <h2 class="ts-cta__title" id="ts-features-cta">Every one of these starts with a single project.</h2>
    <div class="ts-cta__actions">
      @if (userIsLoggedIn) {
        <a class="ts-btn ts-btn--primary ts-btn--lg" [routerLink]="['/dashboard']">
          Open your dashboard <span class="ts-btn__arrow" aria-hidden="true">→</span>
        </a>
      } @else {
        <a class="ts-btn ts-btn--primary ts-btn--lg" [routerLink]="['/account/auth/signup']">
          Start your story <span class="ts-btn__arrow" aria-hidden="true">→</span>
        </a>
      }
      <a class="ts-btn ts-btn--ghost ts-btn--lg" [routerLink]="['/pricing']">See how pricing works</a>
    </div>
  </section>
</article>
